import React, { Children, useContext } from "react";
import PropTypes from "prop-types";
import ConsentRadioButton from "./ConsentRadioButton";
import generateID from "../../../utils/string-utils";
import CBContext from "./CBContext";
var ConsentPurpose = function (props) {
    var title = props.title, id = props.id, description = props.description, acceptRadioLabel = props.acceptRadioLabel, refuseRadioLabel = props.refuseRadioLabel, children = props.children;
    var ConsentAdditionalDetails = Children.toArray(children).filter(
    //ts-ignore
    function (child) {
        return (typeof child === "object" && "props" in child && child.props.__TYPE === "ConsentAdditionalDetails");
    });
    var _id = id || generateID();
    var context = useContext(CBContext);
    var isAcceptAllChecked = context.isAcceptAllChecked, isRefuseAllChecked = context.isRefuseAllChecked;
    return (React.createElement("div", { className: "fr-consent-service" },
        React.createElement("fieldset", { "aria-labelledby": "finality-".concat(_id, "-legend finality-").concat(_id, "-desc"), role: "group", className: "fr-fieldset fr-fieldset--inline" },
            React.createElement("legend", { id: "finality-".concat(_id, "-legend"), className: "fr-consent-service__title" }, title),
            React.createElement(ConsentRadioButton, { refuseAll: isRefuseAllChecked, acceptAll: isAcceptAllChecked, radioName: "purpose", acceptRadioLabel: acceptRadioLabel, refuseRadioLabel: refuseRadioLabel }),
            React.createElement("p", { id: "finality-".concat(_id, "-desc"), className: "fr-consent-service__desc" }, description),
            ConsentAdditionalDetails)));
};
ConsentPurpose.defaultProps = { __TYPE: "ConsentPurpose" };
ConsentPurpose.propTypes = { __TYPE: PropTypes.string };
export default ConsentPurpose;
